export const BASE_URL = "https://n8j790921g.execute-api.us-east-1.amazonaws.com/production/";

export const MOCK = false;
